import { AmplitudeSessionReplayProvider } from "@redotech/redo-merchant-analytics-app/analytics/amplitude-session-replay-provider";
import { memo, type ReactNode } from "react";
import { SUPPLIES_PAYMENT_METHOD_REPLAY_BLOCK_SELECTOR } from "../setting/billing/payment-methods/supplies-session-replay-privacy";

const SUPPLIES_SESSION_REPLAY_BLOCK_SELECTOR = [
  SUPPLIES_PAYMENT_METHOD_REPLAY_BLOCK_SELECTOR,
];

export const RedoSuppliesSessionReplayProvider = memo(
  function RedoSuppliesSessionReplayProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    return (
      <AmplitudeSessionReplayProvider
        blockSelector={SUPPLIES_SESSION_REPLAY_BLOCK_SELECTOR}
        productId="supplies"
      >
        {children}
      </AmplitudeSessionReplayProvider>
    );
  },
);
